export default __webpack_public_path__ + "static/media/woocommerce-product-new.3410941d.gif";